import styles from './PaginationControl.module.css';
import { IonButtons, IonCol, IonGrid, IonRow, IonToolbar } from '@ionic/react';
import PaginationButton from './PaginationButton';
import _ from 'lodash';
import Icon from '@/shared/components/Icon/Icon';
import { useTranslation } from 'react-i18next';

type Props = {
  className?: string;
  currentPage: number;
  numberOfPages: number;
  onPageChange: (page: number) => void;
};

const getPagesToDisplay = (currentPage: number, numberOfPages: number): number[] => {
  let firstPage = _.max([1, currentPage - 2]) || 1;
  const lastPage = _.min([firstPage + 4, numberOfPages]) || numberOfPages;

  firstPage = _.max([lastPage - 4, 1]) || 1;

  return _.range(firstPage, lastPage + 1);
};

const PaginationControl: React.FC<Props> = ({ className, currentPage, numberOfPages, onPageChange }) => {
  const { t } = useTranslation();
  const pages = getPagesToDisplay(currentPage, numberOfPages);

  return (
    <IonGrid fixed={true}>
      <IonRow>
        <IonCol className={styles.pagginationColumn}>
          <IonToolbar className={`${styles.toolbar} ${className || ''}`}>
            <IonButtons slot="end">
              <PaginationButton onClick={() => onPageChange(1)} className={styles.skipBackIcon}>
                <Icon src="assets/icons/play-skip-back-outline.svg" />
              </PaginationButton>
              <PaginationButton onClick={() => onPageChange(_.max([1, currentPage - 1]) || 1)}>
                <Icon src="assets/icons/play-outline.svg" className={styles.backIcon} />
              </PaginationButton>
              {pages.map((page) => (
                <PaginationButton key={page} onClick={() => onPageChange(page)} isSelected={currentPage === page}>
                  {page}
                </PaginationButton>
              ))}
              <PaginationButton onClick={() => onPageChange(_.min([currentPage + 1, numberOfPages]) || numberOfPages)}>
                <Icon src="assets/icons/play-outline.svg" />
              </PaginationButton>
              <PaginationButton onClick={() => onPageChange(numberOfPages)} className={styles.skipForwardIcon}>
                <Icon src="assets/icons/play-skip-forward-outline.svg" />
              </PaginationButton>
              <p className={styles.pageIndex}>{t('transactions.pagination.pages', { currentPage, numberOfPages })}</p>
            </IonButtons>
          </IonToolbar>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default PaginationControl;
